import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Dashboard } from './screens/Dashboard/Dashboard'
import { Settings } from './screens/Settings/Settings'
import { LiveFleet } from './screens/Fleet/LiveFleet'
import { Analytics } from './screens/Analytics/Analytics'
import { Compliance } from './screens/Compliance/Compliance'
import { Safety } from './screens/Safety/Safety'
import { Maintenance } from './screens/Maintenance/Maintenance'
import { Routing } from './screens/Routing/Routing'
import { Login } from './screens/Auth/Login'
import { CommandPalette } from './components/CommandPalette'
import { ProtectedRoute } from './components/ProtectedRoute'
import { ThemeProvider } from './components/theme-provider'
import { AuthProvider } from './contexts/AuthContext'
import './styles/globals.css'

const queryClient = new QueryClient()

// Placeholder components for upcoming screens
function PlaceholderScreen({ title }: { title: string }) {
  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">{title}</h1>
        <p className="text-muted-foreground">Coming Soon - Phase 2</p>
      </div>
    </div>
  )
}

function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="fleetvision-theme">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              
              {/* Protected Routes */}
              <Route path="/" element={<ProtectedRoute><CommandPalette /><Dashboard /></ProtectedRoute>} />
              <Route path="/fleet" element={<ProtectedRoute><CommandPalette /><LiveFleet /></ProtectedRoute>} />
              <Route path="/analytics" element={<ProtectedRoute><CommandPalette /><Analytics /></ProtectedRoute>} />
              <Route path="/compliance" element={<ProtectedRoute><CommandPalette /><Compliance /></ProtectedRoute>} />
              <Route path="/safety" element={<ProtectedRoute><CommandPalette /><Safety /></ProtectedRoute>} />
              <Route path="/maintenance" element={<ProtectedRoute><CommandPalette /><Maintenance /></ProtectedRoute>} />
              <Route path="/routing" element={<ProtectedRoute><CommandPalette /><Routing /></ProtectedRoute>} />
              <Route path="/reports" element={<ProtectedRoute><CommandPalette /><PlaceholderScreen title="Reports Studio" /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><CommandPalette /><Settings /></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

export default App
